import script from "./AppSolution.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSolution.vue?vue&type=script&setup=true&lang=js"

import "./AppSolution.vue?vue&type=style&index=0&id=5df9ad42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5df9ad42"]])

export default __exports__